module.exports = __webpack_public_path__ + "img/sign_out.36c7207a.svg";